import styled from "@emotion/styled";

export const TrialDescription = styled.span`
  color: #B7BDCB;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 21px;
  word-wrap: break-word;
`;

export const PlanHeaderSpan = styled.div`
  color: #B7BDCB;
  font-size: 16px;
  font-family: Inter;
  font-weight: 600;
  word-wrap: break-word;
`;

export const PlanOptionCard = styled.div`
  padding: 12px;
  background: #23252A;
  border-radius: 12px;
  outline: 2px #5E84ED solid;
  outline-offset: -2px;
  flex-direction: column;
  gap: 12px;
  display: flex;
`;

export const CurrentPlanSpan = styled.span`
  color: #E9ECF5;
  font-size: 17px;
  font-family: Inter;
  font-weight: 600;
  line-height: 23.80px;
`;

export const BenefitsRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const BenefitsIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const BenefitsSpan = styled.span`
  color: #B7BDCB;
  font-size: 14px;
  font-family: "Custora", serif;
  font-weight: 400;
  word-wrap: break-word;
`;

export const BillingCycleSpan = styled.span`
  color: #B7BDCB;
  font-size: 14px;
  font-family: Inter;
  font-weight: 500;
`;

export const BillingOptionCard = styled.div<{ selected?: boolean }>`
  display: flex;
  padding: 12px;
  background: ${props => props.selected ? '#23252A' : '#1A1A1C'};
  border-radius: 12px;
  outline: ${props => props.selected ? '2px #5E84ED solid' : '1px #2B2D33 solid'};
  outline-offset: ${props => props.selected ? '-2px' : '-1px'};
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const SelectIcon = styled.span`
  width: 20px;
  height: 20px;
  background: rgba(217, 217, 217, 0);
  border-radius: 9999px;
  border: 1px #B7BDCB solid;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SelectedIconInner = styled.span`
  width: 10px;
  height: 10px;
  background: #5E84ED;
  border-radius: 9999px;
`;

export const BillingCycleDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BillingCycleTitleSpan = styled.span`
  color: #E9ECF5;
  font-size: 15px;
  font-family: Inter;
  font-weight: 500;
  line-height: 21px;
  word-wrap: break-word;
`;

export const BillingCycleDescriptionSpan = styled.span`
  color: #B7BDCB;
  font-size: 13px;
  font-family: Inter;
  font-weight: 400;
  line-height: 140%;
  word-wrap: break-word;
`;

export const BillingCycleHighlightSpan = styled.span`
  color: #8FB0FF;
  font-size: 13px;
  font-family: Inter;
  font-weight: 600;
  line-height: 18.20px;
  word-wrap: break-word;
`;

export const BillingCycleStartsSpan = styled.span`
  color: #B7BDCB;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 140%;
  word-wrap: break-word;
`;
